const formatCDNPath = (path) => {
  const cdnPath = path.replace('s3.us-east-2.amazonaws.com/', '');
  return cdnPath;
};

module.exports = {
  formatCDNPath
};
